<div class="col-md-12 mobile-display-view" style="padding-top: 15px;">
  <div class="game-highlight-wrap" style="background: #fff; padding: 15px; border-radius: 5px;">
    <h3 style="border-bottom: 1px solid #c8ced3; padding-bottom: 10px; margin-bottom: 15px;">Tips & Previews</h3>
    <div class="row">
      <div class="col-md-12" *ngFor="let tip of tipsPreviews" style="margin-bottom: 15px;">
        <div class="card" style="border: 1px solid #c8ced3; border-radius: 5px;">
          <div class="card-body" style="padding: 15px;">
            <h5 class="card-title" style="margin-bottom: 10px;">
              <a [routerLink]="['/tips', tip.id]" style="color: #000; text-decoration: none; font-weight: bold;">
                {{ tip.title }}
              </a>
            </h5>
            <h6 class="card-subtitle mb-2 text-muted" style="font-size: 12px;">{{ tip.date }}</h6>
            <p class="card-text" style="font-size: 14px;">{{ tip.summary }}</p>
            <a [routerLink]="['/tips', tip.id]" class="btn btn-primary" style="background-color: #2789ce; border-color: #2789ce; color: white; padding: 5px 10px; font-size: 12px; border-radius: 3px;">Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
